const Footer = () => {
  return (
    <footer className="pt-3 pb-1 px-5">
      <p>
        <a href="https://www.endu.net/">ENDU</a> - Engagigo srl - P.IVA
        02804190342 - <a href="https://www.endu.net/terms"> T&C </a>-
        <a href="https://www.endu.net/privacy"> Privacy Policy </a>-
        <a href="https://www.endu.net/cookies"> Cookie Policy </a>
      </p>
    </footer>
  );
};

export default Footer;
